export const THEMES = [
    { id: "child", label: "Child" },
    { id: "english", label: "English" },
    { id: "chinese", label: "Chinese" },
    { id: "linguist", label: "Oxford Linguist" },
];
const LABELS = {
    hiss: {
        child: "snake sound",
        english: "sh (ship)",
        chinese: "sh (shi)",
        linguist: "voiceless postalveolar fricative",
    },
    airy: {
        child: "windy sound",
        english: "f (fun)",
        chinese: "f (fa)",
        linguist: "voiceless labiodental fricative",
    },
    pop: {
        child: "pop sound",
        english: "p (pop)",
        chinese: "p (pa)",
        linguist: "voiceless bilabial plosive",
    },
    buzz: {
        child: "buzzy sound",
        english: "z (zoo)",
        chinese: "z (zi)",
        linguist: "voiced alveolar fricative",
    },
    hum: {
        child: "humming sound",
        english: "m (moon)",
        chinese: "m (ma)",
        linguist: "voiced bilabial nasal",
    },
};
export function labelFor(clusterId, theme) {
    return LABELS[clusterId]?.[theme] ?? CUSTOM_LABELS[clusterId] ?? clusterId;
}
const CUSTOM_LABELS = {};
export function registerCustomLabel(clusterId, label) {
    CUSTOM_LABELS[clusterId] = label;
}
export function customLabels() {
    return { ...CUSTOM_LABELS };
}
export { registerCustomIcon } from "./icons.js";
